define('root/Assets/Js/Projects',[
	'jquery',
	'base/MbiHelper',
	'project/MbiConfig',
	'base/MbiImageSize'
	//'project/ScrollStateHandler'
], function(
	$,
	_,
	mbiConfig,
	mbiImageSize
	//scrollStateHandler
) {
	'use strict';

	var location = window.history.location || window.location;

	var module = {


		loadMoreContainerClass:		'js_moreProject_container',
		loadMoreButtonClass:		'js_loadmore',
		loadDetailButtonClass: 		'js_detail',
		loadLocationButtonClass: 	'js_location',
		loadViewButtonClass: 		'js_view',
		projectsOverviewButtonClass: 	'js_overview',
		projectDetailContentClass: 	'js_blog-detail-content',
		projectBodyClass: 				'page-template-projects',
		singleprojectBodyClass: 		'js_blog-single',
		projectDetailActiveClass: 		'is_detail',

		isOverview:					true, // @todo: use this to determine if OVERVIEW or SINGLE page
		supportHistory:					true, // @todo: use this to determine if history is supported

		lockButtons: function() {

			// $('.'+module.loadMoreButtonClass + ', .'+module.loadDetailButtonClass + ', .'+module.projectsOverviewButtonClass).addClass('is_locked');

		},
		unlockButtons: function() {

			// $('.'+module.loadMoreButtonClass + ', .'+module.loadDetailButtonClass + ', .'+module.projectsOverviewButtonClass).removeClass('is_locked is_loading');

		},

		init: function() {


			//check if history.js is supported
			if (window.history && window.history.pushState) {
				module.supportHistory = true;
			} else {
				module.supportHistory = false;
			}
			module.clickHandler();



			//if(Modernizr.history) {
			if(module.supportHistory) {

				if(_.exists('.'+module.projectBodyClass) || _.exists('.'+module.singleprojectBodyClass)) {

					require(['project/Vendor/History'], function() {
						// load history plugin
					});
				}

				if(_.exists('.'+module.projectBodyClass)) {

					var state = {
						'projectDetail': false,
						'scrollTop': $(window).scrollTop()
					};
					window.history.replaceState(state, null, location.href);

				}

			}

		},

		clickHandler: function() {

			$(document).on('click', '.'+module.loadMoreButtonClass, function(e) {

				e.preventDefault();

				if(!$(this).hasClass('is_locked')) {

					module.lockButtons();
					module.onClickLoadMoreButton(this);

				}

			});
			$(document).on('click', '.'+module.loadLocationButtonClass, function(e) {

				e.preventDefault();

				if(!$(this).hasClass('is_locked')) {

					module.lockButtons();
					module.onClickLoadLocationButton(this);

				}

			});
			$(document).on('click', '.'+module.loadViewButtonClass, function(e) {

				e.preventDefault();

				if(!$(this).hasClass('is_locked')) {

					module.lockButtons();
					module.onClickLoadViewButton(this);

				}

			});



			window.onpopstate = function(e) {
				if (module.supportHistory) {

					var state = window.history.state;
					if (_.exists('.'+module.projectBodyClass)) {

						if (state != null && typeof state.projectDetail != 'undefined' && state.projectDetail ){
							var request = {
								'targetUrl':  state.targetUrl,
								'push': false,
								'title': ''
							};
							module.fetchDetailContent(request);
						} else {
							module.backToProjectsOverview();
						}
						if (state != null) {
							_.scrollToTarget('',500,state.scrollTop);
						}
					} else if (_.exists('.'+module.singleprojectBodyClass)) {
						if (state != null && typeof state.projectDetail != 'undefined' && !state.projectDetail ){
							window.location.reload();
						}
					}
				}

			}

		},
		updateQueryStringParameter: function(uri, key, value) {

			var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
			var separator = uri.indexOf('?') !== -1 ? "&" : "?";

			if (uri.match(re)) {
				return uri.replace(re, '$1' + key + "=" + value + '$2');
			} else {
				return uri + separator + key + "=" + value;
			}

		},

		onClickLoadMoreButton: function(that) {

			var $button = $(that),
				$parent = $(that).parent(),
				pageID = $parent.attr('data-page'),
				active = $parent.attr('data-location');

			var targetUrl = $button.attr('href');
			var data = {
				action: 'load_more',
				location: active,
				pageID: pageID,
				'active': 'grid'
			};
			$button.addClass('is_locked is_loading');

			$.ajax({
				dataType: 	'json',
				//url:		targetUrl,
				data: 		data,
				timeout:	10000,
				error:		function() {

					module.unlockButtons();

				},
				success: 	function(response) {

					//$('.'+module.loadMoreContainerClass).replaceWith(response.html);
					$parent.html(response.html);

					setTimeout(function() {

						mbiImageSize.checker();

						//scrollStateHandler.refresh();

						//module.initLoadMoreOnScroll();

						var url = location.href,
						state = window.history.state;
						url = module.updateQueryStringParameter(url, 'load', pageID);

						window.history.replaceState(state, null, url);
						module.unlockButtons();

					}, 100);

				}

			});

		},

		onClickLoadLocationButton: function(that) {
			var $button = $(that);
			if (!$button.hasClass('location-active')) {
				var $projects = $(that).parents('.js_projects'),
				location_local = $(that).attr('data-key'),
				action = 'load_location',
				active = 'grid';

				$('.js_location').removeClass('location-active');
				$button.addClass('location-active');
				if ($projects.hasClass('view-grid')) {
					var data = {
						'location': location_local,
						'action': action,
						'active': active
					};

					$.ajax({
						dataType: 'json',
						data: data,
						timeout: 10000,
						error: function(){},
						success: function(response){
							$('.js_projects_grid').html(response.html);
							setTimeout(function() {

								// mbiImageSize.checker();
								mbiImageSize.init();
							}, 150);



						}

					});
				} else {

					module.loadProjectsMap($projects);
				}

				setTimeout(function() {
					mbiImageSize.checker();

					var url = location.href,
						state = window.history.state;
					url = module.updateQueryStringParameter(url, 'location', location_local);

					window.history.replaceState(state, null, url);
					module.unlockButtons();

				}, 1);
			}
		},
		onClickLoadViewButton: function(that) {
			var $button = $(that);
			if (!$button.hasClass('is_active')) {
				$('.js_view').removeClass('is_active');
				$(that).addClass('is_active');
				var $projects = $(that).parents('.js_projects'),
					view = $(that).attr('data-view');

				$projects.removeClass('view-grid').removeClass('view-map').addClass(view);

				if (view == 'view-map') {
					module.loadProjectsMap($projects);
				} else {
					var $location = $('.js_location.location-active');
					$('.js_location').removeClass('location-active');
					$location.trigger('click');
				}

				setTimeout(function() {

					var url = location.href,
						state = window.history.state;
					url = module.updateQueryStringParameter(url, 'view', view);

					window.history.replaceState(state, null, url);
					module.unlockButtons();

				}, 10);
			}
		},

	 	loadProjectsMap: function($projects) {
			var location = $projects.find('.location-active').attr('data-key');
			var data = {
				'location': location,
				'action': 'get_projects',
				'active': 'map'
			};

			$.ajax({
				dataType: 'json',
				data: data,
				timeout: 10000,
				error: function(){console.log('error');},
				success: function(response){

					var projects = response.projects,
					coordinate = response.coordinate.split(',');;
					var center = {
						'lat': parseFloat(coordinate[0]),
						'lng': parseFloat(coordinate[1]),
					};
					var distance = parseInt(coordinate[2]);
					require(['async!https://maps.googleapis.com/maps/api/js?key=AIzaSyAWa0kyl97q47RfBQUItmk98kptT7qe00g&v=3.exp&libraries=places'], function(){

						module.loadMap(projects, center,distance);
					});
				}

			});
		},

		loadMap: function(locations,center, distance) {

			var initGoogleMaps;
				require(['project/MbiGoogleMaps'], function(mbiGoogleMaps) {

					initGoogleMaps = function() {

						if(_.exists('.googleMaps')) {

							var styles = [
						    {
						        "stylers": [
						            {
						                "saturation": -100
						            },
						            {
						                "gamma": 0.8
						            },
						            {
						                "lightness": 4
						            },
						            {
						                "visibility": "on"
						            }
						        ]
						    },
						    {
						        "featureType": "landscape.natural",
						        "stylers": [
						            {
						                "visibility": "on"
						            },
						            {
						                "color": "#ccc"
						            },
						            {
						                "gamma": 4.97
						            },
						            {
						                "lightness": -5
						            },
						            {
						                "saturation": 100
						            }
						        ]
						    }
						];

							var markerClickedHandler = function(marker, address) {
								// var id = $('#'+ address.elementID).parents('.js_location').attr('data-id');
								// $('.module--contact[data-active]').attr('data-active', id);

							};
							var zoom = 11;
							if (distance > 30) {
								zoom = 13;
							}
							//console.log(distance+ ' ' + zoom);

							var args = {
								distance: distance,
								center: {
									latitude: center.lat,
									langtitude: center.lng

								},
								mapOptions: {

									zoom: zoom,
									center: {},

									scrollwheel: false,
									navigationControl: false,
									mapTypeControl: false,
									scaleControl: true,
									panControl: true,
									streetViewControl: true,
									zoomControl: true,
									draggable: true,
									mapTypeId: 'ROADMAP',
									styles: styles

								},
								extraOptions: {

									mapCanvasID: "projectsLocations", //canvas container id
									markerIconUrl: window.homePath + "/Assets/Svg/pin.svg",
									markerIconWidth: 14,
									markerIconHeight: 21,
									markerCurrentLocationIconUrl: window.homePath + "/Assets/Svg/pin.svg",
									markerCurrentLocationIconWidth: 14,
									markerCurrentLocationIconHeight: 21,
									markerPath: 'CIRCLE', // path can be google.maps.SymbolPath.{BACKWARD_CLOSED_ARROW/BACKWARD_OPEN_ARROW/CIRCLE/FORWARD_CLOSED_ARROW/FORWARD_OPEN_ARROW} or SVG path notation
									showAll: false,
									maxZoomIn: 16,
									maxZoomOut: 8,
									locations: locations,
									markerClickCallback: markerClickedHandler

								}

							};

							mbiGoogleMaps.init(args);
							//mbiGoogleMaps.createAllLocationsMark();
							mbiGoogleMaps.createAllLocationsMarkAndInfowindow();

						}

					}

					initGoogleMaps();

				});

		}





	};

	mbiConfig.modules.Projects = true;

	module.init();

	return module;

});
